<div class="wb-colmgr" *ngIf="ready">
  <div class="wb-colmgr__modes" role="tablist" aria-label="Column manager mode">
    <button
      type="button"
      role="tab"
      class="wb-colmgr__mode"
      [class.wb-colmgr__mode--active]="mode === 'pick'"
      [attr.aria-selected]="mode === 'pick'"
      (click)="setMode('pick')"
    >
      Pick
    </button>
    <button
      type="button"
      role="tab"
      class="wb-colmgr__mode"
      [class.wb-colmgr__mode--active]="mode === 'reorder'"
      [attr.aria-selected]="mode === 'reorder'"
      (click)="setMode('reorder')"
    >
      Reorder
    </button>
  </div>

  <input
    type="search"
    class="wb-colmgr__search"
    placeholder="Search columns..."
    aria-label="Search columns"
    [value]="query"
    (input)="setQuery($event)"
  />

  <!-- Pick: grouped by column source, sections in the server's group order. -->
  <div class="wb-colmgr__body" *ngIf="mode === 'pick'">
    <div
      class="wb-colmgr__group"
      *ngFor="let group of groups; trackBy: trackGroup"
    >
      <div class="wb-colmgr__group-head">
        <button
          type="button"
          class="wb-colmgr__chevron"
          [attr.aria-expanded]="!group.collapsed"
          [attr.aria-label]="
            (group.collapsed ? 'Expand ' : 'Collapse ') + group.label
          "
          (click)="toggleCollapse(group.label)"
        >
          <i
            class="mdi"
            [class.mdi-chevron-right]="group.collapsed"
            [class.mdi-chevron-down]="!group.collapsed"
          ></i>
        </button>
        <input
          type="checkbox"
          class="wb-colmgr__check"
          [checked]="group.allOn"
          [indeterminate]="group.partial"
          [attr.aria-label]="'Toggle all ' + group.label + ' columns'"
          (change)="toggleGroup(group)"
        />
        <span class="wb-colmgr__group-label">{{ group.label }}</span>
        <span class="wb-colmgr__count">{{ group.countLabel }}</span>
      </div>

      <div class="wb-colmgr__items" *ngIf="!group.collapsed">
        <div
          class="wb-colmgr__item"
          *ngFor="let item of group.items; trackBy: trackItem"
          [attr.data-col-id]="item.colId"
        >
          <i
            #grip
            class="mdi mdi-drag-vertical wb-colmgr__grip wb-colmgr__grip--active"
            aria-hidden="true"
          ></i>
          <input
            type="checkbox"
            class="wb-colmgr__check"
            [checked]="item.visible"
            [attr.aria-label]="item.label"
            (change)="toggleColumn(item)"
          />
          <span class="wb-colmgr__item-label" [title]="item.label">{{
            item.label
          }}</span>
        </div>
      </div>
    </div>

    <p class="wb-colmgr__empty" *ngIf="!groups.length">No columns match.</p>
  </div>

  <!-- Reorder: flat list in grid order, each row tagged with its group. -->
  <div class="wb-colmgr__body" *ngIf="mode === 'reorder'">
    <div
      class="wb-colmgr__item wb-colmgr__item--reorder"
      *ngFor="let item of reorderItems; trackBy: trackItem"
      [attr.data-col-id]="item.colId"
    >
      <i
        #grip
        class="mdi mdi-drag-vertical wb-colmgr__grip wb-colmgr__grip--active"
        aria-hidden="true"
      ></i>
      <input
        type="checkbox"
        class="wb-colmgr__check"
        [checked]="item.visible"
        [attr.aria-label]="item.label"
        (change)="toggleColumn(item)"
      />
      <span class="wb-colmgr__item-label" [title]="item.label">{{
        item.label
      }}</span>
      <span class="wb-colmgr__badge">{{ item.group }}</span>
    </div>

    <p class="wb-colmgr__empty" *ngIf="!reorderItems.length">
      No columns match.
    </p>
  </div>
</div>
